import React from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import './Welcome.css';

const Welcome = () => {
  const navigate = useNavigate();
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const fetchUser = async () => {
      if (!supabase) return;

      try {
        const { data: { user: currentUser } } = await supabase.auth.getUser();
        setUser(currentUser);
      } catch (error) {
        console.error('Welcome: Error fetching user:', error);
      }
    };

    fetchUser();
  }, []);

  return (
    <div className="welcome-page">
      <div className="container">
        <h1>Tervetuloa{user?.user_metadata?.full_name ? `, ${user.user_metadata.full_name}` : ''}!</h1>
        
        <div className="welcome-content">
          <p className="welcome-intro">
            Astrologinen kartta vaatii tarkan syntymäajan ja -paikan.
          </p>
          <p>
            Tietoja käytetään vain henkilökohtaisiin tulkintoihin ja astrologiakarttojen luomiseen.
          </p>
        </div>

        <div className="progress-indicator">
          <div className="progress-step active">
            <span className="step-number">1</span>
            <span className="step-label">Tili luotu</span>
          </div>
          <div className="progress-line"></div>
          <div className="progress-step">
            <span className="step-number">2</span>
            <span className="step-label">Syntymätiedot</span>
          </div>
          <div className="progress-line"></div>
          <div className="progress-step">
            <span className="step-number">3</span>
            <span className="step-label">Kartta valmis</span>
          </div>
        </div>

        <button 
          onClick={() => navigate('/profile-setup')} 
          className="btn btn-primary btn-large"
        >
          Syötä syntymätiedot
        </button>
      </div>
    </div>
  );
};

export default Welcome;
